export function getImageKitUrl(value: any, ...args: any[]): any {
  let path;
  try {
    const url = new URL(value);
    path = url.pathname;
  } catch (error) {
    path = value;
  }
  return path;
}
